import { render, staticRenderFns } from "./userDetails.vue?vue&type=template&id=98a15ac4&scoped=true"
import script from "./userDetails.vue?vue&type=script&lang=js"
export * from "./userDetails.vue?vue&type=script&lang=js"
import style0 from "./userDetails.vue?vue&type=style&index=0&id=98a15ac4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a15ac4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98a15ac4')) {
      api.createRecord('98a15ac4', component.options)
    } else {
      api.reload('98a15ac4', component.options)
    }
    module.hot.accept("./userDetails.vue?vue&type=template&id=98a15ac4&scoped=true", function () {
      api.rerender('98a15ac4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/admin/userDetails.vue"
export default component.exports